import { Component, OnInit, Input } from '@angular/core';
import { Offerte } from '../model/offerte';
import { HostListener } from '@angular/core'

@Component({
  selector: 'app-offerte-min',
  templateUrl: './offerte-min.component.html',
  styleUrls: ['./offerte-min.component.scss']
})
export class OfferteMinComponent implements OnInit {
 

  @Input () offerta:Offerte ;
  @Input () indice:number ;

  
  mobile = false;

  ngOnInit() {
    console.log(window.screen.width);
    if (window.screen.width <= 768|| window.innerWidth<=768) { // 768px portrait
      this.mobile = true;
      console.log(this.mobile);
    }
  }

  @HostListener('window:resize', ['$event'])
onResize(event) {
  if (window.screen.width <= 768 || window.innerWidth<=768) { // 768px portrait
    this.mobile = true;
  }
  else
  {
    this.mobile=false;
  }
}

  


}



// WEBPACK FOOTER //
// ./src/app/offerte-min/offerte-min.component.ts